module.exports = __webpack_public_path__ + "static/media/selloE.2b1e994c.png";